import checkmarkIcon from "@illustrations/checkmark-circle-80x80.png";

const NoBill = () => (
    <>
        <div className="flex items-center justify-center gap-2 py-1">
            <img src={checkmarkIcon} alt="Checkmark" className="w-10 h-10" />
            <p className="font-medium italic text-base leading-6 text-neutral-950 tracking-[0.16px]">
                Up to date. No payment needed.
            </p>
        </div>
    </>
);

export default NoBill;
